var _style, _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedicalSpecialistStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "medical-specialist-star_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M66.3 921.4s-24.5-195 148.3-343.3S601 490 601 490s36.8 6.4 86.2 30.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M494.6 65.8c50.3 0 97.6 19.6 133.2 55.2 35.6 35.6 55.2 82.9 55.2 133.2s-19.6 97.6-55.2 133.2c-35.6 35.6-82.9 55.2-133.2 55.2-50.3 0-97.6-19.6-133.2-55.2s-55.2-82.9-55.2-133.2c0-50.3 19.6-97.6 55.2-133.2 35.6-35.6 82.9-55.2 133.2-55.2m0-65C354.7.8 241.2 114.2 241.2 254.2c0 139.9 113.4 253.4 253.4 253.4 139.9 0 253.4-113.4 253.4-253.4C748 114.3 634.5.8 494.6.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 826.3,
    cy: 678.4,
    r: 13,
    fill: "#f9af1c",
    stroke: "#f9af17",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9af1c",
    stroke: "#f9af17",
    strokeMiterlimit: 10,
    strokeWidth: 13,
    d: "M995 732.4c-1.6-5-6.1-8.5-11.3-8.9L855 712.6l-1.3-3-.9-2.2c-2.2-4.1-6.5-6.9-11.5-6.9-7.2 0-13 5.8-13 13 0 1.5.3 3 .7 4.3l.7 1.6 4.5 10.5c1.9 4.4 6.1 7.5 10.9 7.9l106.1 9-80.7 70.8c-3.6 3.2-5.2 8-4.1 12.7l23.9 104.2-91.7-55.2c-2.1-1.2-4.4-1.9-6.7-1.9s-4.6.6-6.7 1.9l-91.7 55.2 24.1-105c1.1-4.7-.5-9.6-4.2-12.7l-80.7-70 106.5-9.4c4.8-.4 9-3.5 10.8-7.9l41.9-98.7 7.2 16.9.6 1.5c2.1 4.3 6.6 7.2 11.7 7.2 7.2 0 13-5.8 13-13 0-1.4-.2-2.7-.6-4l-.9-2.2-19.1-44.7c-2-4.8-6.8-7.9-12-7.9 0 0 0 0 0 0-5.2 0-9.9 3.1-12 7.9L729 712l-129.3 11.4c-5.2.5-9.6 4-11.2 9-1.6 5-.1 10.4 3.9 13.8l98 84.9-29.2 127.3c-1.2 5.1.8 10.4 5 13.4 4.2 3.1 9.9 3.3 14.3.6l111.2-67 111.3 67c2.1 1.2 4.4 1.9 6.7 1.9 2.7 0 5.4-.8 7.6-2.5 4.2-3.1 6.2-8.4 5-13.4l-29-126.4 97.8-85.8c4.1-3.4 5.5-8.8 3.9-13.8z"
  }))));
}

export default SvgMedicalSpecialistStar;